import { render, staticRenderFns } from "./klaviyo-form.vue?vue&type=template&id=4d3839d9&scoped=true&lang=pug&"
import script from "./klaviyo-form.vue?vue&type=script&lang=coffee&"
export * from "./klaviyo-form.vue?vue&type=script&lang=coffee&"
import style0 from "./klaviyo-form.vue?vue&type=style&index=0&id=4d3839d9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3839d9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormTextfield: require('/opt/build/repo/library/components/globals/form/textfield.vue').default,Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default})
